module.exports = function() {
  return new Worker(__webpack_public_path__ + "7de877fc4f53bffcee69.worker.js");
};